import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "indexoptions"
    }}>{`IndexOptions`}</h1>
    <p>{`Index options.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the IndexOptions (a Document or Application).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`title`}</strong>{` `}</p>
      <p parentName="blockquote">{`The title of the generated index.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`titleStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to the title of the generated index. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`replaceExistingIndex`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, replaces the content of the existing index. Note: Replaces only index content; does not update the index location or other index properties that may have been changed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeBookDocuments`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, includes topics and page references from all the documents in a book.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeHiddenEntries`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, includes topics and page references on hidden layers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`IndexFormat `}<strong parentName="p">{`indexFormat`}</strong>{` `}</p>
      <p parentName="blockquote">{`The format for level 2 and lower index topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeSectionHeadings`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays the letters of the alphabet as index section headings.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeEmptyIndexSections`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, displays headings for sections with no index topics. Note: Valid only when include section headings is true.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`level1Style`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to level 1 index topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`level2Style`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to level 2 index topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`level3Style`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to level 3 index topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`level4Style`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to level 4 index topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ParagraphStyle `}<strong parentName="p">{`sectionHeadingStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The paragraph style applied to index section headings. Note: Valid when include section headings is true.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CharacterStyle `}<strong parentName="p">{`pageNumberStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character style applied to page numbers in the index.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CharacterStyle `}<strong parentName="p">{`crossReferenceStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character style applied to cross references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CharacterStyle `}<strong parentName="p">{`crossReferenceTopicStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character style applied to cross reference topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`followingTopicSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted after each index topic.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`betweenEntriesSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted between index entries when runin-style index format is used for nested topics.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`pageRangeSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted between page numbers to indicate a page range.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`betweenPageNumbersSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted between separate page numbers, page numbers and page ranges, and series of page ranges.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`beforeCrossReferenceSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted at the start of cross references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`entryEndSeparator`}</strong>{` `}</p>
      <p parentName="blockquote">{`The character(s) inserted at the end of each index entry.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the IndexOptions.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`IndexOptions `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      